const campaignQueryKey = (campaignId: string): [string, string] => [
  'campaign',
  campaignId,
];

export default campaignQueryKey;
